"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const dayjs_1 = __importDefault(require("dayjs"));
const OverclaimHistoryRow = (props) => {
    const { historyRow } = props;
    return (react_1.default.createElement("div", { className: 'history-row-wrapper' },
        react_1.default.createElement("div", { className: 'history-row' },
            react_1.default.createElement("div", { className: 'history-cell' },
                react_1.default.createElement("div", null, "Last Update"),
                react_1.default.createElement("div", null, (0, dayjs_1.default)(historyRow.createdAt).utc().format('MMMM DD, YYYY'))),
            react_1.default.createElement("div", { className: 'history-cell' },
                react_1.default.createElement("div", null, "Action"),
                react_1.default.createElement("div", null, historyRow.notificationType)),
            react_1.default.createElement("div", { className: 'history-cell' },
                react_1.default.createElement("div", null, "Action Completed By"),
                react_1.default.createElement("div", null, historyRow.createdByMember)))));
};
exports.default = OverclaimHistoryRow;
